export { CorporativoLandingRegional } from "./CorporativoLandingRegional";
